import { applyMiddleware } from "redux";

import { autoRehydrate } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import bagMiddleware from "./middleware/bag";
import bodyScrollMiddleware from "./middleware/bodyScroll";
import actionDeferralMiddleware from "./middleware/actionDeferral";
import thunk from "redux-thunk";
import * as api from "../../api";
import {
  asosGlobalNamespace,
  sdkGlobalNamespace
} from "../../template/constants";

export default () =>
  composeWithDevTools({ name: "SiteChrome" })(
    applyMiddleware(
      actionDeferralMiddleware, //must go first!
      thunk.withExtraArgument({
        api,
        get identity() {
          return window[asosGlobalNamespace][sdkGlobalNamespace].identity;
        }
      }),
      bagMiddleware,
      bodyScrollMiddleware
    ),
    autoRehydrate()
  );
